const IconClose = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.30555 1.82295C-0.10185 1.41555 -0.10185 0.755024 0.30555 0.347625L0.347624 0.30555C0.755023 -0.101849 1.41555 -0.101849 1.82295 0.30555L17.6945 16.1771C18.1019 16.5845 18.1019 17.245 17.6945 17.6524L17.6524 17.6945C17.245 18.1019 16.5845 18.1019 16.1771 17.6945L0.30555 1.82295Z"
        fill="white"
      />
      <path
        d="M1.82295 17.6945C1.41555 18.1019 0.755023 18.1019 0.347624 17.6945L0.30555 17.6524C-0.10185 17.245 -0.10185 16.5845 0.305549 16.1771L16.1771 0.30555C16.5845 -0.10185 17.245 -0.10185 17.6524 0.305549L17.6945 0.347623C18.1019 0.755022 18.1019 1.41555 17.6945 1.82295L1.82295 17.6945Z"
        fill="white"
      />
    </svg>
  );
};

export default IconClose;
